<!--*
 * Modal to show how to use the application
 *
 * @author   mauricio.figueroa
 * @date     2024-16-01
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <AppModal :title="$t('drillDownScreen.pageTitle')" :show="show"
            show-close @on-close-click="closeHandler" @on-click-outside="closeHandler">
    <DrillDown />
  </AppModal>
</template>

<script>
import DrillDown from "@/components/drillDown/DrillDown.vue";
import AppModal from "@/components/SharedComponents/AppModal.vue";

export default {
  'name': 'DrillDownModal',
  components: { AppModal, DrillDown },
  'props': {
    'show': {
      'type': Boolean,
      'default': false
    },
  },
  'methods': {
    closeHandler() {
      this.$emit('dismiss');
    }
  }
}
</script>
